import * as yup from 'yup';
import { Row, Column, EMPTY_ARRAY, RenderConfig, SelectInput, TextInput } from 'commons-ui';
import _get from 'lodash/get';
import {
	FEATURE_TYPE_OPTIONS,
	PG_NAME_OPTIONS,
	EFeatureType,
	PAYMENT_MODE_CHECKOUT_OPTIONS,
	PAYMENT_MODE_PAYOUT_OPTIONS,
	INSTRUMENT_TYPE_ALL_OPTIONS,
	EPaymentConfigModeType,
	INSTRUMENT_TYPE_CHECKOUT_NB_OPTIONS,
	INSTRUMENT_TYPE_CHECKOUT_WALLET_OPTIONS,
	INSTRUMENT_TYPE_CHECKOUT_UPI_OPTIONS,
	INSTRUMENT_CARD_TYPE_OPTIONS,
	INSTRUMENT_NETWORK_OPTIONS,
	DEFAULT_OPTIONS,
	INSTRUMENT_ISSUER_OPTIONS,
	DOWNTIME_TYPE_OPTIONS,
	DOWNTIME_OPTIONS
} from './constants';

export const paymentModeDependencyResolver = (props: any, dependencyValues: any) => {
	const featureType = _get(dependencyValues, '0');
	if (featureType === EFeatureType.CHECKOUT) {
		return { options: PAYMENT_MODE_CHECKOUT_OPTIONS };
	}
	return { options: PAYMENT_MODE_PAYOUT_OPTIONS };
};

export const instrumentCardTypeDependencyResolver = (props: any, dependencyValues: any) => {
	const featureType = _get(dependencyValues, '0');
	const paymentMode = _get(dependencyValues, '1');
	if (featureType === EFeatureType.CHECKOUT && paymentMode === EPaymentConfigModeType.cards) {
		return { options: INSTRUMENT_CARD_TYPE_OPTIONS, required: true, disabled: false };
	}
	return { required: false, disabled: true };
};

export const instrumentNetworkDependencyResolver = (props: any, dependencyValues: any) => {
	const featureType = _get(dependencyValues, '0');
	const paymentMode = _get(dependencyValues, '1');
	if (featureType === EFeatureType.CHECKOUT && paymentMode === EPaymentConfigModeType.cards) {
		return { options: INSTRUMENT_NETWORK_OPTIONS, disabled: false };
	}
	return { required: false, disabled: true };
};

export const instrumentIssuerDependencyResolver = (props: any, dependencyValues: any) => {
	const featureType = _get(dependencyValues, '0');
	const paymentMode = _get(dependencyValues, '1');
	if (featureType === EFeatureType.CHECKOUT && paymentMode === EPaymentConfigModeType.cards) {
		return { options: INSTRUMENT_ISSUER_OPTIONS, disabled: false };
	}
	return { required: false, disabled: true };
};

export const instrumentTypeDependencyResolver = (props: any, dependencyValues: any) => {
	const featureType = _get(dependencyValues, '0');
	const paymentMode = _get(dependencyValues, '1');
	let newDependency: any = { required: false, disabled: true };
	if (featureType === EFeatureType.CHECKOUT) {
		if (paymentMode === EPaymentConfigModeType.upi) {
			newDependency = { options: INSTRUMENT_TYPE_CHECKOUT_UPI_OPTIONS, required: true, disabled: false };
		} else if (paymentMode === EPaymentConfigModeType.netbanking) {
			newDependency = { options: INSTRUMENT_TYPE_CHECKOUT_NB_OPTIONS, required: true, disabled: false };
		} else if (paymentMode === EPaymentConfigModeType.wallet) {
			newDependency = { options: INSTRUMENT_TYPE_CHECKOUT_WALLET_OPTIONS, required: true, disabled: false };
		}
		return newDependency;
	}
	return { options: INSTRUMENT_TYPE_ALL_OPTIONS, required: true, disabled: false };
};

export const FORM_FIELD_KEYS = {
	IS_ACTIVE: 'isActive',
	FEATURE_TYPE: 'featureType',
	PAYMENT_MODE: 'paymentMode',
	PG_NAME: 'pgName',
	INSTRUMENT_TYPE: 'instrumentType',
	CARD_TYPE: 'cardType',
	NETWORK: 'network',
	ISSUER: 'issuer',
	DOWNTIME_TYPE: 'downtimeType',
	MESSAGE: 'message',
	START_TIME: 'startTime',
	END_TIME: 'endTime',
	CREATED_BY: 'createdBy',
	SCHEDULE: 'schedule'
};

export const FORM_LAYOUT_EDIT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.START_TIME)]), new Column([new Row(FORM_FIELD_KEYS.END_TIME)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.IS_ACTIVE)]), new Column([new Row(FORM_FIELD_KEYS.MESSAGE)])])
];

export const FORM_LAYOUT_CREATE_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.FEATURE_TYPE)]), new Column([new Row(FORM_FIELD_KEYS.PG_NAME)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.PAYMENT_MODE)]),
		new Column([new Row(FORM_FIELD_KEYS.INSTRUMENT_TYPE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.CARD_TYPE)]), new Column([new Row(FORM_FIELD_KEYS.NETWORK)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ISSUER)]), new Column([new Row(FORM_FIELD_KEYS.DOWNTIME_TYPE)])]),
	...FORM_LAYOUT_EDIT_CONFIG
];

export const FORM_FIELD_EDIT_CONFIG = {
	[FORM_FIELD_KEYS.START_TIME]: new RenderConfig()
		.setName('startTime')
		.setLabel('Start Time')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss'
		}),
	[FORM_FIELD_KEYS.END_TIME]: new RenderConfig()
		.setName('endTime')
		.setLabel('End Time')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			inputType: 'datetime-local',
			format: 'yyyy-dd-mm HH:MM:ss'
		}),
	[FORM_FIELD_KEYS.IS_ACTIVE]: new RenderConfig()
		.setName('isActive')
		.setLabel('downtime')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: DOWNTIME_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.MESSAGE]: new RenderConfig()
		.setName('message')
		.setLabel('Message')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_FIELD_CREATE_CONFIG = {
	[FORM_FIELD_KEYS.FEATURE_TYPE]: new RenderConfig()
		.setName('featureType')
		.setLabel('Feature Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: FEATURE_TYPE_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.PG_NAME]: new RenderConfig()
		.setName('pgName')
		.setLabel('PG Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: PG_NAME_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.PAYMENT_MODE]: new RenderConfig()
		.setName('paymentMode')
		.setLabel('Payment Mode')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: DEFAULT_OPTIONS,
			dependencies: ['featureType'],
			dependencyResolver: paymentModeDependencyResolver,
			required: true
		}),
	[FORM_FIELD_KEYS.INSTRUMENT_TYPE]: new RenderConfig()
		.setName('instrumentType')
		.setLabel('Instrument Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: DEFAULT_OPTIONS,
			dependencies: ['featureType', 'paymentMode'],
			dependencyResolver: instrumentTypeDependencyResolver
		}),
	[FORM_FIELD_KEYS.CARD_TYPE]: new RenderConfig()
		.setName('cardType')
		.setLabel('Card Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: DEFAULT_OPTIONS,
			dependencies: ['featureType', 'paymentMode'],
			dependencyResolver: instrumentCardTypeDependencyResolver
		}),
	[FORM_FIELD_KEYS.NETWORK]: new RenderConfig()
		.setName('network')
		.setLabel('Network')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: DEFAULT_OPTIONS,
			dependencies: ['featureType', 'paymentMode'],
			dependencyResolver: instrumentNetworkDependencyResolver
		}),
	[FORM_FIELD_KEYS.ISSUER]: new RenderConfig()
		.setName('issuer')
		.setLabel('Issuer')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: DEFAULT_OPTIONS,
			dependencies: ['featureType', 'paymentMode'],
			dependencyResolver: instrumentIssuerDependencyResolver,
			searchable: true
		}),
	[FORM_FIELD_KEYS.DOWNTIME_TYPE]: new RenderConfig()
		.setName('downtimeType')
		.setLabel('Downtime Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: DOWNTIME_TYPE_OPTIONS,
			required: true
		}),
	...FORM_FIELD_EDIT_CONFIG
};

export const validationSchema = yup.object().shape({
	message: yup
		.string()
		.test('len', 'Message should be of appropriate length!', (val) => !val || val.length > 1 || val.length < 50)
		.optional()
});
